var _path, _path2, _polygon, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSkins(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M27.99,256c15.43,0,28.01-10.94,28.01-24.5V32L.87,225.46c-4.48,15.57,8.97,30.54,27.12,30.54Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M511.14,225.46l-55.14-193.46V231.5c0,13.56,12.58,24.5,28.01,24.5,18.2,0,31.59-14.96,27.13-30.54Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "currentColor",
    points: "127.78 192 127.78 224 223.58 256 223.58 512 287.45 512 288.35 256 384.16 224 384.16 192.9 127.78 192.9 127.78 192"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M448.03,210.9C448.03,90.38,256.42,0,256.42,0,256.42,0,63.91,90.38,63.91,210.9c0,82.75-22.83,145.9-31.07,180.6-3.37,14.5,3.62,29.38,16.35,35.25l174.39,85.25V256l-95.8-32v-32h255.48l.9,32-95.8,32v255.1s174.54-85.25,174.54-85.25c12.6-5.87,19.71-20.75,16.22-35.25-8.23-33.8-31.09-97-31.09-179.7Z",
    isolation: "isolate",
    opacity: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkins);
export default __webpack_public_path__ + "static/media/skins.b8a942e84756a916e933d2f6b0f30691.svg";
export { ForwardRef as ReactComponent };